import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

/**
 * Hidden arcade leaderboard store (C). One best document per user per game on
 * the server; this store holds the top list, the caller's own entry and the
 * result of the last submission.
 */
class ArcadeScoreStore extends LocalModel {
    constructor() {
        super('arcadeScore', {
            namePlural: 'arcadeScores',
            namePluralReal: 'arcadescores',
            sort: '-score',
            limit: 10,
            api: {
                search: {
                    url: '/api/arcadescores/',
                    params: {
                        limit: 10,
                        sort: '-score',
                    },
                },
                load: {
                    url: '/api/arcadescores/',
                    params: {},
                },
                save: {
                    url: '/api/arcadescores/',
                    params: {},
                },
                delete: {
                    url: '/api/arcadescores/',
                    params: {},
                },
            },
        });
    }

    @observable arcadeScore = {};

    @observable arcadeScores = [];

    @observable leaderboard = [];

    @observable me = null;

    @observable lastSubmit = null;

    @observable isLoading = false;

    @observable leaderboardGame = null;

    // Personal best per game key (the cabinet title screen shows all of them).
    @observable bestByGame = {};

    @action
    async loadLeaderboard(game = 'spaceInvaders', limit = 10) {
        this.updateKeyValue('isLoading', true);
        const response = await util.fetchApi('/api/arcadescores/', { method: 'GET' }, { game, limit });
        if (response?.status === 200) {
            this.updateKeyValue('leaderboard', Array.isArray(response.data) ? response.data : []);
            this.updateKeyValue('me', response.me || null);
            this.updateKeyValue('leaderboardGame', game);
            this.updateKeyValue('bestByGame', { ...this.bestByGame, [game]: response.me || null });
        }
        this.updateKeyValue('isLoading', false);
        return response;
    }

    @action
    async loadBests(games) {
        const keys = Array.isArray(games) ? games : [];
        for (let i = 0; i < keys.length; i += 1) {
            // Sequential on purpose: tiny list, one code path.
            // eslint-disable-next-line no-await-in-loop
            await this.loadLeaderboard(keys[i]);
        }
        return this.bestByGame;
    }

    @action
    async submitScore({
        game = 'spaceInvaders', score, wave, durationMs, won,
    }) {
        const response = await util.fetchApi('/api/arcadescores/', { method: 'POST' }, {
            game, score, wave, durationMs, ...(won === undefined ? {} : { won }),
        });
        if (response?.status === 200 || response?.status === 201) {
            this.updateKeyValue('lastSubmit', response.data || null);
        }
        return response;
    }
}

const store = new ArcadeScoreStore();

export default store;
